import { getCurrentInstance, computed } from 'vue';
import { useActions, useState } from 'vuex-composition-helpers';
import { type FilerProductType } from '@ve/components/hotel/filters/common/store/types';
import { MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
import { NAMESPACE as MAP_FOR_SEARCH_DATA } from '@ve/pages/serp/store/SearchDataStore';
import { IMapForSearchDataState } from '@ve/pages/serp/store'

const filtersMappingStoreName = 'mapForFilters';
const datesTabsModuleName = 'mapForDatesTabs';

export default () => {
    const {
        selectDateManually,
    } = useActions(datesTabsModuleName, ['selectDateManually']);

    const {
        products,
        block,
    } = useState<MapForFiltersState>(filtersMappingStoreName, ['products', 'block']);

    const {
        searchCountries,
        searchDepartureCity,
    } = useState<IMapForSearchDataState>(MAP_FOR_SEARCH_DATA, ['searchCountries', 'searchDepartureCity']);

    const proxy = getCurrentInstance()?.proxy;

    const {
        action_isExclusive: setIsExclusive,
        action_productType: setProductType,
        action_operators: setOperators,
        action_meals: setMeals,
    } = useActions(filtersMappingStoreName, ['action_isExclusive', 'action_productType', 'action_operators', 'action_meals',]);

    const selectProductTypeFilter = (filerProductType: FilerProductType) => {
        selectDateManually();
        setProductType(filerProductType);
    };

    const selectOperatorFilter = (operators: number[]) => {
        proxy?.$root.$emit('operator-filter-changed');
        setOperators(operators);
    };

    const changeIsExclusiveFilter = (isExclusive: boolean) => {
        setIsExclusive(isExclusive);
    };

    const selectMealsFilter = (meals: number[]) => {
        proxy?.$root.$emit('meal-filter-changed', meals);
        setMeals(meals);
    };

    const changeWarrantedFilter = (warranted: boolean) => {
        proxy?.$root.$emit('warranted-filter-changed', warranted);
    };

    const changeDirectFlightFilter = (directFlight: boolean) => {
        proxy?.$root.$emit('direct-flight-changed', directFlight);
    };

    const changeBonusMilesFilter = (bonusMiles: boolean) => {
        proxy?.$root.$emit('bonus-miles-changed', bonusMiles);
    };

    const resetAdditionalFilters = () => {
        changeIsExclusiveFilter(false);
        changeBonusMilesFilter(false);
    }

    const blockModel = computed({
        get: () => block.value,
        set: (value: boolean) => {
            setOperators([]);
            setMeals([]);
            setIsExclusive(false);
            setProductType('all');
            changeDirectFlightFilter(false);
            changeBonusMilesFilter(false);
            proxy?.$root.$emit('block-changed', value);
        }
    })

    return {
        resetAdditionalFilters,
        selectMealsFilter,
        selectProductTypeFilter,
        selectOperatorFilter,
        changeIsExclusiveFilter,
        changeWarrantedFilter,
        changeDirectFlightFilter,
        changeBonusMilesFilter,
        searchCountries,
        searchDepartureCity,
        blockModel,
        products,
    };
};